import { AnalyticsBrowser } from '@segment/analytics-next';
import React, { useMemo } from 'react';

import { AnalyticsContext, AnalyticsContextProps } from './context';
import config from '../config';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  const writeKey = config.SEGMENT_WRITE_KEY ?? '';

  const value: AnalyticsContextProps = useMemo(() => ({ analytics: AnalyticsBrowser.load({ writeKey }) }), [writeKey]);

  return <AnalyticsContext.Provider value={value}>{children}</AnalyticsContext.Provider>;
};
